import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter, ApiPage } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/pasme/pasma";

export const fetchAnimalBreeds = createAsyncThunk(
  "breed/list",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        new ApiPage().page(0).size(1000).toQueryString(),
        new ApiFilter().or((orGroup) => {
          orGroup.where("species", "EQ", "KOZA");
          orGroup.where("species", "EQ", "OVCA");
        }),
        null
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchAnimalBreedsPage = createAsyncThunk(
  "breed/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [fetchAnimalBreeds, fetchAnimalBreedsPage];

const breedSlice = createSlice({
  name: "breeds",
  initialState: {
    list: [],
    page: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAnimalBreeds.fulfilled, (state, action) => {
      state.page = action.payload;
      state.list = action.payload.content;
    });
    builder.addCase(fetchAnimalBreedsPage.fulfilled, (state, action) => {
      state.page = action.payload;
      state.list = action.payload.content;
    });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default breedSlice.reducer;
